import React from 'react';

export const DAILY_DUTY_TEMPLATES = [
 ['eg_opening','Opening checklist','eg'],['eg_during','During shift & shift change','eg'],
 ['eg_sweep','Clean sweeps','eg'],['eg_laundry','EG laundry','eg'],
 ['eg_closing','Closing checklist','eg'],['mt_laundry','MT laundry','mt']
];

// This edits the existing Room Assignments side_duties records, using its Save.
export default function DailyDutyOwners({duties=[],roster=[],onChange,disabled=false}) {
 const assign=(template,label,employeeId)=>{
  const person=roster.find(p=>p.employee_id===employeeId);
  const existing=duties.find(d=>d.duty_template===template);
  const next={...(existing || {id:`sd_${crypto.randomUUID()}`,label}),
   role:template==='mt_laundry'?'massage_therapist':'front_desk',duty_template:template,
   owners:person?[{user_id:person.employee_id,user_name:person.employee_name,done_at:null}]:[]};
  onChange(existing?duties.map(d=>d.id===existing.id?next:d):[...duties,next]);
 };
 return <section className="daily-duty-owners" aria-label="Daily checklist owners">
  <h2>Daily checklist owners</h2><p>Assign the owner here, then save Room Assignments. Staff see only their own duties.</p>
  <div>{DAILY_DUTY_TEMPLATES.map(([key,label,family])=>{
   const duty=duties.find(d=>d.duty_template===key);
   const people=roster.filter(p=>family==='mt'?p.role==='massage_therapist':['front_desk','experience_guide'].includes(p.role));
   return <label key={key}><span>{label}</span><select aria-label={`${label} owner`} disabled={disabled} value={duty?.owners?.[0]?.user_id || ''} onChange={e=>assign(key,label,e.target.value)}><option value="">Unassigned</option>{people.map(p=><option key={p.employee_id} value={p.employee_id}>{p.employee_name} · {p.shift}</option>)}</select></label>;
  })}</div>
 </section>;
}


// Browser printing uses the same duty keys, order and snapshot as the editor.
export function DailyDutyOwnerPrint({duties=[],roster=[]}) {
 return <section className="journey-planning-print__duty-owners" aria-label="Daily checklist owners">
  <h2>Daily checklist owners</h2>
  <dl>{DAILY_DUTY_TEMPLATES.map(([key,label])=>{
   const duty=duties.find(item=>item.duty_template===key);
   const names=(duty?.owners||[]).map(owner=>roster.find(person=>String(person.employee_id)===String(owner.user_id))?.employee_name||owner.user_name||'Name unavailable');
   return <div key={key}><dt>{label}</dt><dd>{names.length?names.join(', '):'Unassigned'}</dd></div>;
  })}</dl>
 </section>;
}
